import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AuthenticateDomainService } from 'src/app/private/services/authenticate-domain.service';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { TrackingService } from 'src/app/private/services/tracking.service';

@Component({
  selector: 'app-add-auth-domain',
  templateUrl: './add-auth-domain.component.html',
  styleUrls: ['./add-auth-domain.component.scss']
})
export class AddAuthDomainComponent {
  domain: string = '';
  spf: any = null;
  dkim: any[] = [];
  isAddDomain: boolean = true;
  isShowDetails: boolean = false;
  btnLoading: boolean = false;
  isShowEditDetails: boolean = false;
  isShowMessage: boolean = false;
  apiMessage: string = '';
  apiStatus: string = '';
  domainWasAdded: boolean = false;
  @Output() close = new EventEmitter<boolean>();

  @Input() type: 'Add' | 'View' = 'Add';
  @Input() domainData: any;

  constructor(
    private domainAuthService: AuthenticateDomainService,
    private localStorage: LocalStorageService,
    private toastr: ToastrService,
    private tracker: TrackingService,
  ) {}

  ngOnInit() {
    console.log('AddAuthDomainComponent initialized with type:', this.type);
    console.log('Domain data:', this.domainData);
    if (this.type == 'View') {
      this.initDomainAuth(this.domainData);
    }
  }


  initDomainAuth(response: any) {
    this.domain = response.domain;

    // Check if response contains a message (e.g., domain already verified)
    if (response.message && response.status) {
      this.apiMessage = response.message;
      this.apiStatus = response.status;
      this.isShowMessage = true;
      this.isShowDetails = false;
      this.isShowEditDetails = false;
    } else if (response.spf && typeof response.spf === 'object') {
      // Support new format (spf object)
      this.spf = response.spf;
      this.dkim = response.dkim || [];
      this.isShowDetails = true;
      this.isShowEditDetails = false;
      this.isShowMessage = false;
    } else {
      // Support old list-view format (spf_token string)
      this.spf = response.spf_token;
      this.dkim = response.dkim_tokens || [];
      this.isShowDetails = false;
      this.isShowEditDetails = true;
      this.isShowMessage = false;
    }

    this.isAddDomain = false;
  }

  copyToClipboard(value: string) {
    navigator.clipboard.writeText(value).then(() => {
      console.log('Copied:', value);
    });
  }

  submitDomainAuth() {

    const payload = {
      hospital_id: this.localStorage.getHospitalId(),
      domain: this.domain,
    };

    this.btnLoading = true;
    this.domainAuthService.authenticateClientDomain(payload).subscribe({
      next: (response) => {
        this.toastr.success('Domain authentication initiated successfully.');
        this.domainWasAdded = true;
        this.initDomainAuth(response);
        this.btnLoading = false;

        const desc = `Authentication initiated for domain: ${this.domain}`;
        this.tracker.track("Create", "Domain Authentication", desc);
      },
      error: (error) => {
        console.error('Error during domain authentication:', error);
        this.toastr.error('Failed to initiate domain authentication. Please try again.');
        this.btnLoading = false;
      }
    });

  }

  closeModal() {
    this.close.emit(this.domainWasAdded);
  }
}
